export interface RechargeBonusLevel {
    id: number
    threshold: number | string
    bonus_amount: number | string
    status?: number
}

export interface RechargeBonusConfig {
    status?: number
    levels?: RechargeBonusLevel[]
}

export interface RechargePaymentOption {
    label: string
    value: number
}

interface RechargeBonusFormValues {
    amount?: number | string
    bonus_amount?: number | string | null
}

const ACTIVITY_STATUS_NORMAL = 0
const LEVEL_STATUS_NORMAL = 0
const PAYMENT_CONFIG_CASH = 0
const PAYMENT_CONFIG_ALIPAY = 2
const PAYMENT_CONFIG_WEIXIN = 3
const PAYMENT_CONFIG_BANKCARD = 4

export const defaultRechargePaymentOptions: RechargePaymentOption[] = [
    { label: '现金', value: 0 },
    { label: '个人微信', value: 6 },
    { label: '个人支付宝', value: 5 },
    { label: '银行卡', value: 7 },
]

const rechargePaymentConfigMap: Record<number, number> = {
    0: PAYMENT_CONFIG_CASH,
    6: PAYMENT_CONFIG_WEIXIN,
    5: PAYMENT_CONFIG_ALIPAY,
    7: PAYMENT_CONFIG_BANKCARD,
}

export const getEnabledRechargePaymentOptions = (enabledPaymentList?: number[]) => {
    if (!enabledPaymentList) return defaultRechargePaymentOptions

    return defaultRechargePaymentOptions.filter(option =>
        enabledPaymentList.includes(rechargePaymentConfigMap[option.value]),
    )
}

export const getActiveRechargeBonusLevels = (config?: RechargeBonusConfig): RechargeBonusLevel[] => {
    if (!config || config.status !== ACTIVITY_STATUS_NORMAL) return []

    return (config.levels || []).filter(level => level.status === LEVEL_STATUS_NORMAL)
}

export const getActiveRechargeBonusLevelByAmount = (levels: RechargeBonusLevel[], amount: any) => {
    if (amount === undefined || amount === null || amount === '') return undefined

    return [...levels]
        .filter(level => level.status === LEVEL_STATUS_NORMAL && Number(amount) >= Number(level.threshold))
        .sort((a, b) => Number(b.threshold) - Number(a.threshold))[0]
}

export const getRechargeBonusSubmitParams = (values: RechargeBonusFormValues, levels: RechargeBonusLevel[]) => {
    const activeLevel = getActiveRechargeBonusLevelByAmount(levels, values.amount)
    if (activeLevel) {
        return {
            activity_level_id: activeLevel.id,
            bonus_amount: Number(activeLevel.bonus_amount),
        }
    }

    return {
        activity_level_id: 0,
        bonus_amount: Number(values.bonus_amount || 0),
    }
}

export const getRechargeBonusAmountAfterAmountChange = (amount: any, levels: RechargeBonusLevel[]) => {
    const activeLevel = getActiveRechargeBonusLevelByAmount(levels, amount)

    return activeLevel ? Number(activeLevel.bonus_amount) : 0
}
